import * as S from "./styles.ts";
import { createEditor } from "slate";
import { useState } from "react";
import { Slate, withReact } from "slate-react";
import EditorContent from "@admin/config/overrides/fieldTypes/MarkdownEditor/children/EditorContent";
import Toolbar from "@admin/config/overrides/fieldTypes/MarkdownEditor/children/Toolbar";

const defaultValue = (value: string | any[] = "") => {
  if (typeof value !== "string") return value;

  return [
    {
      type: "paragraph",
      children: [{ text: value }],
    },
  ];
};

const TextEditor = ({ value, onChange, disabled }) => {
  const [editor] = useState(() => withReact(createEditor()));

  return (
    <Slate
      editor={editor}
      initialValue={defaultValue(value)}
      onChange={(val) => (disabled ? null : onChange(val))}
    >
      <S.TextEditorContainer>
        <Toolbar disabled={disabled} />
        <EditorContent disabled={disabled} />
      </S.TextEditorContainer>
    </Slate>
  );
};

export default TextEditor;
